import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Badge, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import type { IRowBadge } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/components/LLMTable/types";
import type { IAiTrackerTableRow } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/types";

export const getRowTags = (row: IAiTrackerTableRow): ReactElement[] => {
    const config: IRowBadge[] = [
        {
            key: "in-progress",
            text: translate("llm.homepage.table.column.campaign_name.tag.in_progress"),
            isDisplayed: !row.isCompleted && !row.isFailed,
        },
        {
            key: "demo",
            text: translate("llm.homepage.table.column.campaign_name.tag.demo"),
            isDisplayed: row.isDemo,
        },
        {
            key: "view-only",
            text: translate("llm.homepage.table.column.campaign_name.tag.view_only"),
            isDisplayed: !row.canEdit,
        },
        {
            key: "failed",
            text: translate("llm.homepage.table.column.campaign_name.tag.failed"),
            tooltipValue: translate("llm.homepage.table.column.campaign_name.tag.failed"),
            isDisplayed: row.isFailed,
        },
    ];

    return config.map(
        ({ key, text, isDisplayed, tooltipValue }) =>
            isDisplayed && (
                <Tooltip
                    content={tooltipValue}
                    enabled={!!tooltipValue}
                >
                    <span data-automation={`ai-tracker-row-badge-${key}`}>
                        <Badge
                            type="neutral"
                            color={colorsPalettes.carbon[500]}
                        >
                            {text}
                        </Badge>
                    </span>
                </Tooltip>
            ),
    );
};
